import { useAuth } from '@shared/common/providers/AuthProvider';

import { RaffleCell } from './cells/RaffleCell';
import { RewardCell } from './cells/RewardCell';
import { TicketsCell } from './cells/TicketsCell';
import { TableSkeleton } from './TableSkeleton';
import { TableLabel } from './TableTitle';
import { EntriesTableProps } from './types';

export const EntriesTableMobile = ({
  rounds,
  onClickRow,
  isEmpty,
  isLoading,
}: EntriesTableProps) => {
  const { userEvmWallet } = useAuth();

  return (
    <div>
      {!isEmpty && (
        <div className="flex flex-col border-b border-base-border-medium self-start pb-2">
          <TableLabel>Raffle</TableLabel>
        </div>
      )}
      {
        <div>
          {rounds.map((round) => {
            return (
              <div
                onClick={() => onClickRow(round.roundId)}
                key={round.roundId}
                className="
                  flex flex-col gap-1 pt-3 pb-2
                  border-b border-base-border-medium last:border-0
                  cursor-pointer
                "
              >
                <div className="flex justify-between py-2">
                  <RaffleCell row={round} />
                </div>
                <div className="flex justify-between py-2">
                  <TableLabel>Reward</TableLabel>
                  <RewardCell row={round} walletAddress={userEvmWallet?.attributes?.address} />
                </div>
                <div className="flex justify-between py-2">
                  <TableLabel>My Tickets</TableLabel>
                  <TicketsCell row={round} />
                </div>
              </div>
            );
          })}
        </div>
      }
      {isEmpty && (
        <p className="my-[96px] m-auto text-center text-base-text-tertiary text-sm">No data yet</p>
      )}
      {isLoading && <TableSkeleton />}
    </div>
  );
};
